import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import LessonIsland from "react-app/islands/LessonIsland"

interface Signature {
  Args: {
    course: Course
    planbook: Planbook
    rotationCalendar: RotationCalendar
    dateString: string
    editCourseTitleAndOrder: Function
    lessonsCollapsed: boolean
    perspective: "day" | "week" | "month"
    isFullScreen?: boolean
    /** List an existing lesson only — don't invent a phantom for an empty day. */
    existingOnly?: boolean
    /** The caller's `{{else}}` for an unfulfilled slot: the LessonLoading skeleton, or nothing. */
    showLoadingSkeleton?: boolean
    /** The caller's `(not courseDate.hideFromCalendar)` gate, where its `.hbs` wrote one. */
    hideWhenHiddenFromCalendar?: boolean
    /** No drag pad, and no drag: a lesson shown out of its calendar has nowhere to move to. */
    dragDisabled?: boolean
  }
}

/**
 * The unified-lesson entry: react-renders the React resolver, which resolves the day's lesson —
 * inventing its phantom when the day has none — through supergrain. Consumers reach it only when
 * `planbook.flags.unifiedLessons` is on; legacy planbooks keep the
 * `Planner::CardStacks::Lesson::Provider` + `LessonEditable` path.
 *
 * The template's dev-only first branch is `dev-lesson-editor-switch`: a unified planbook picks the
 * island from its flag alone, so a lesson switched to legacy has to be routed back to Ember here.
 */
export default class LessonIslandBridge extends Component<Signature> {
  readonly LessonIsland = LessonIsland
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Bridges::LessonIslandBridge": typeof LessonIslandBridge
  }
}
